__turbopack_context__.v({
  "btnHero": "RedesignOnkormanyzat-module__XMgZAa__btnHero",
  "btnHeroOutline": "RedesignOnkormanyzat-module__XMgZAa__btnHeroOutline",
  "checkIcon": "RedesignOnkormanyzat-module__XMgZAa__checkIcon",
  "contactEmail": "RedesignOnkormanyzat-module__XMgZAa__contactEmail",
  "contactSection": "RedesignOnkormanyzat-module__XMgZAa__contactSection",
  "contactSub": "RedesignOnkormanyzat-module__XMgZAa__contactSub",
  "contactTitle": "RedesignOnkormanyzat-module__XMgZAa__contactTitle",
  "ctaBtn": "RedesignOnkormanyzat-module__XMgZAa__ctaBtn",
  "emailAt": "RedesignOnkormanyzat-module__XMgZAa__emailAt",
  "emailDot": "RedesignOnkormanyzat-module__XMgZAa__emailDot",
  "eyebrowDark": "RedesignOnkormanyzat-module__XMgZAa__eyebrowDark",
  "eyebrowDot": "RedesignOnkormanyzat-module__XMgZAa__eyebrowDot",
  "fbCard": "RedesignOnkormanyzat-module__XMgZAa__fbCard",
  "fbCardDesc": "RedesignOnkormanyzat-module__XMgZAa__fbCardDesc",
  "fbCardTitle": "RedesignOnkormanyzat-module__XMgZAa__fbCardTitle",
  "fbCards": "RedesignOnkormanyzat-module__XMgZAa__fbCards",
  "fbDark": "RedesignOnkormanyzat-module__XMgZAa__fbDark",
  "fbDarkLabel": "RedesignOnkormanyzat-module__XMgZAa__fbDarkLabel",
  "fbGrid": "RedesignOnkormanyzat-module__XMgZAa__fbGrid",
  "fbIconBlue": "RedesignOnkormanyzat-module__XMgZAa__fbIconBlue",
  "fbIconGreen": "RedesignOnkormanyzat-module__XMgZAa__fbIconGreen",
  "fbResult": "RedesignOnkormanyzat-module__XMgZAa__fbResult",
  "fbResultAccent": "RedesignOnkormanyzat-module__XMgZAa__fbResultAccent",
  "fbSection": "RedesignOnkormanyzat-module__XMgZAa__fbSection",
  "fbStep": "RedesignOnkormanyzat-module__XMgZAa__fbStep",
  "fbStepNum": "RedesignOnkormanyzat-module__XMgZAa__fbStepNum",
  "fbStepNumBlue": "RedesignOnkormanyzat-module__XMgZAa__fbStepNumBlue",
  "fbStepText": "RedesignOnkormanyzat-module__XMgZAa__fbStepText",
  "footer": "RedesignOnkormanyzat-module__XMgZAa__footer",
  "footerBrand": "RedesignOnkormanyzat-module__XMgZAa__footerBrand",
  "footerCopy": "RedesignOnkormanyzat-module__XMgZAa__footerCopy",
  "footerLinks": "RedesignOnkormanyzat-module__XMgZAa__footerLinks",
  "footerLogo": "RedesignOnkormanyzat-module__XMgZAa__footerLogo",
  "heroCard": "RedesignOnkormanyzat-module__XMgZAa__heroCard",
  "heroCta": "RedesignOnkormanyzat-module__XMgZAa__heroCta",
  "heroSub": "RedesignOnkormanyzat-module__XMgZAa__heroSub",
  "heroTitle": "RedesignOnkormanyzat-module__XMgZAa__heroTitle",
  "includedCheck": "RedesignOnkormanyzat-module__XMgZAa__includedCheck",
  "includedDesc": "RedesignOnkormanyzat-module__XMgZAa__includedDesc",
  "includedGrid": "RedesignOnkormanyzat-module__XMgZAa__includedGrid",
  "includedItem": "RedesignOnkormanyzat-module__XMgZAa__includedItem",
  "includedList": "RedesignOnkormanyzat-module__XMgZAa__includedList",
  "includedSection": "RedesignOnkormanyzat-module__XMgZAa__includedSection",
  "includedTitle": "RedesignOnkormanyzat-module__XMgZAa__includedTitle",
  "moduleCard": "RedesignOnkormanyzat-module__XMgZAa__moduleCard",
  "moduleCardFull": "RedesignOnkormanyzat-module__XMgZAa__moduleCardFull",
  "moduleDesc": "RedesignOnkormanyzat-module__XMgZAa__moduleDesc",
  "moduleElementsLabel": "RedesignOnkormanyzat-module__XMgZAa__moduleElementsLabel",
  "moduleHeader": "RedesignOnkormanyzat-module__XMgZAa__moduleHeader",
  "moduleIcon": "RedesignOnkormanyzat-module__XMgZAa__moduleIcon",
  "moduleName": "RedesignOnkormanyzat-module__XMgZAa__moduleName",
  "moduleTag": "RedesignOnkormanyzat-module__XMgZAa__moduleTag",
  "moduleTagline": "RedesignOnkormanyzat-module__XMgZAa__moduleTagline",
  "moduleTags": "RedesignOnkormanyzat-module__XMgZAa__moduleTags",
  "modulesGrid": "RedesignOnkormanyzat-module__XMgZAa__modulesGrid",
  "modulesSection": "RedesignOnkormanyzat-module__XMgZAa__modulesSection",
  "pageHero": "RedesignOnkormanyzat-module__XMgZAa__pageHero",
  "priceFeatures": "RedesignOnkormanyzat-module__XMgZAa__priceFeatures",
  "priceLabel": "RedesignOnkormanyzat-module__XMgZAa__priceLabel",
  "priceSub": "RedesignOnkormanyzat-module__XMgZAa__priceSub",
  "priceValue": "RedesignOnkormanyzat-module__XMgZAa__priceValue",
  "section": "RedesignOnkormanyzat-module__XMgZAa__section",
  "sectionLabel": "RedesignOnkormanyzat-module__XMgZAa__sectionLabel",
  "sectionSub": "RedesignOnkormanyzat-module__XMgZAa__sectionSub",
  "sectionTitle": "RedesignOnkormanyzat-module__XMgZAa__sectionTitle",
  "serverCard": "RedesignOnkormanyzat-module__XMgZAa__serverCard",
  "serverCardSub": "RedesignOnkormanyzat-module__XMgZAa__serverCardSub",
  "serverCardTitle": "RedesignOnkormanyzat-module__XMgZAa__serverCardTitle",
  "serverSpec": "RedesignOnkormanyzat-module__XMgZAa__serverSpec",
  "serverSpecDot": "RedesignOnkormanyzat-module__XMgZAa__serverSpecDot",
  "serverSpecText": "RedesignOnkormanyzat-module__XMgZAa__serverSpecText",
  "serverSpecs": "RedesignOnkormanyzat-module__XMgZAa__serverSpecs",
  "site": "RedesignOnkormanyzat-module__XMgZAa__site",
  "videoBadge": "RedesignOnkormanyzat-module__XMgZAa__videoBadge",
  "videoCard": "RedesignOnkormanyzat-module__XMgZAa__videoCard",
  "videoGrid": "RedesignOnkormanyzat-module__XMgZAa__videoGrid",
  "videoInfo": "RedesignOnkormanyzat-module__XMgZAa__videoInfo",
  "videoThumb": "RedesignOnkormanyzat-module__XMgZAa__videoThumb",
  "videoTitle": "RedesignOnkormanyzat-module__XMgZAa__videoTitle",
  "whyCard": "RedesignOnkormanyzat-module__XMgZAa__whyCard",
  "whyDesc": "RedesignOnkormanyzat-module__XMgZAa__whyDesc",
  "whyGrid": "RedesignOnkormanyzat-module__XMgZAa__whyGrid",
  "whyIcon": "RedesignOnkormanyzat-module__XMgZAa__whyIcon",
  "whyTitle": "RedesignOnkormanyzat-module__XMgZAa__whyTitle",
});
